import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { customStorage } from "@/hooks/CustomLocalStorage";
import Cookies from "js-cookie";
import { DefaultTopAgency } from "@/domains/Dashboard/types";
import { DEFAULT_TOP_AGENCY } from "@/domains/Dashboard/components/useMe";

interface AgencyState {
	agency_id: string;
	agency_name: string;
	agency_id_order_page: string;
	agency_name_order_page: string;
	default_top_agency_id: DefaultTopAgency["id"];
	default_top_agency_name: DefaultTopAgency["name"];
}

const initialState: AgencyState = {
	agency_id: "",
	agency_name: "",
	agency_id_order_page: "",
	agency_name_order_page: "",
	default_top_agency_id: DEFAULT_TOP_AGENCY.id,
	default_top_agency_name: DEFAULT_TOP_AGENCY.name,
};

const agencySlice = createSlice({
	name: "agency",
	initialState,
	reducers: {
		setAgencyInfo(state, action: PayloadAction<{ agency_id: string; agency_name: string }>) {
			state.agency_id = action.payload.agency_id;
			state.agency_name = action.payload.agency_name;
			customStorage.setItem("agency_id", action.payload.agency_id);
			customStorage.setItem("selected_agency_name", action.payload.agency_name);
			Cookies.set("agency_id", action.payload.agency_id);
			Cookies.set("selected_agency_name", action.payload.agency_name);
		},
		setDefaultTopAgencyInfo(state, action: PayloadAction<DefaultTopAgency>) {
			state.default_top_agency_id = action.payload.id;
			state.default_top_agency_name = action.payload.name;

			customStorage.setItem("default_top_agency_id", action.payload.id);
			customStorage.setItem("default_top_agency_name", action.payload.name);

			customStorage.setItem("agency_id", String(action.payload.id));
			Cookies.set("agency_id", String(action.payload.id));
		},
		setAgencyInfoForOrderPage(state, action: PayloadAction<{ agency_id: string; agency_name: string }>) {
			state.agency_id_order_page = action.payload.agency_id;
			state.agency_name_order_page = action.payload.agency_name;
		},
		clearAgencyInfo(): AgencyState {
			customStorage.removeItem("agency_id");
			customStorage.removeItem("selected_agency_name");

			Cookies.remove("agency_id");
			Cookies.remove("selected_agency_name");

			return {
				agency_id: "",
				agency_name: "",
				agency_id_order_page: "",
				agency_name_order_page: "",
				default_top_agency_id: 0,
				default_top_agency_name: "",
			};
		},
	},
});

export const { setAgencyInfo, setDefaultTopAgencyInfo, setAgencyInfoForOrderPage, clearAgencyInfo } =
	agencySlice.actions;
export default agencySlice.reducer;
